import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./HeroSection.css";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div className="hero-container">
      <h1>
        Elevate Real Estate. <br /> Captivate Buyers.
      </h1>
      

      <video src="/videos/video-1.mp4" autoPlay loop muted id="myVideo" />
      <div className="hero-btns">
        <Link to="/services">
          <Button
            className="btn-primary"
            buttonStyle="fm-btn--primary" // ✅ new style name
            buttonSize="fm-btn--large" // ✅ new size name
          >
            Learn More
          </Button>
        </Link>
        <Link to="/contact">
          <Button
            className="btn-mobile"
            buttonStyle="fm-btn--outline"
            buttonSize="fm-btn--large"
          >
            Get Started
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default HeroSection;
